import { render } from "./qna_write.vue?vue&type=template&id=4c1d0d49"
import script from "./qna_write.vue?vue&type=script&lang=js"
export * from "./qna_write.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__